import { render, staticRenderFns } from "./OInlineWidget.vue?vue&type=template&id=3988c60c&scoped=true&"
import script from "./OInlineWidget.vue?vue&type=script&lang=js&"
export * from "./OInlineWidget.vue?vue&type=script&lang=js&"
import style0 from "./OInlineWidget.vue?vue&type=style&index=0&id=3988c60c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3988c60c",
  null
  
)

export default component.exports